import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { MuiAutocomplete, TextField } from '@thirdspacelearning/library';

interface Props extends FieldRenderProps<string[]> {
    label: string;
    required?: boolean;
}

const AutocompleteFinalField: FC<Props> = ({
    label,
    input,
    required,
    meta,
    ...rest
}) => {
    const showError = (meta.touched || meta.submitFailed) && meta.error;

    return (
        <MuiAutocomplete
            multiple
            options={[]}
            value={Array.isArray(input.value) ? input.value : []}
            onChange={(_, newValue) => {
                if (typeof newValue === 'string') {
                    input.onChange([newValue]);
                } else if (Array.isArray(newValue)) {
                    input.onChange(newValue);
                } else {
                    input.onChange([]);
                }
            }}
            onBlur={input.onBlur}
            onFocus={input.onFocus}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={required ? `${label} *` : label}
                    placeholder="Type and press Enter"
                    error={!!showError}
                    helperText={showError}
                />
            )}
            slotProps={{
                chip: {
                    variant: 'outlined',
                },
            }}
            {...rest}
        />
    );
};

export default AutocompleteFinalField;
